<template>
  <layout-header />
  <layout-sidebar />
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap"
        >
          <div class="me-2 mb-2">
            <!-- <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="#" class="dropdown-item rounded-1"
                  v-can="'Role.Export'"
                    ><i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a
                  >
                </li>
                <li>
                  <a href="#" class="dropdown-item rounded-1"
                  v-can="'Role.Export'"
                    ><i class="ti ti-file-type-xls me-1"></i>Export as Excel</a
                  >
                </li>
              </ul>
            </div> -->
          </div>
          <div class="mb-2">
            <a
              href="javascript:void(0);"
              data-bs-toggle="modal"
              data-bs-target="#role_modal"
              class="btn btn-primary d-flex align-items-center"
              v-can="'Role.Create'"
            >
              <i class="ti ti-circle-plus me-2"></i>Add Roles
            </a>
          </div>
          <div class="head-icons ms-2">
            <a
              href="javascript:void(0);"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <!-- Roles Table -->
      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Roles List</h5>
          <div
            class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
          >
            <div class="me-3">
              <div class="input-icon-end position-relative">
                <input
                  type="text"
                  class="form-control date-range bookingrange"
                  ref="dateRangeInput"
                  placeholder="dd/mm/yyyy - dd/mm/yyyy"
                />
                <span class="input-icon-addon"
                  ><i class="ti ti-chevron-down"></i
                ></span>
              </div>
            </div>
            <div class="dropdown me-3">
              <a
                href="#"
                class="dropdown-toggle btn btn-white"
                data-bs-toggle="dropdown"
                >Status</a
              >
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="#"
                    class="dropdown-item rounded-1"
                    @click.prevent="filterStatus('Active')"
                    >Active</a
                  >
                </li>
                <li>
                  <a
                    href="#"
                    class="dropdown-item rounded-1"
                    @click.prevent="filterStatus('Inactive')"
                    >Inactive</a
                  >
                </li>
                <li>
                  <a
                    href="#"
                    class="dropdown-item rounded-1"
                    @click.prevent="filterStatus('All')"
                    >All</a
                  >
                </li>
              </ul>
            </div>
            <div class="dropdown">
              <a
                href="#"
                class="dropdown-toggle btn btn-white"
                data-bs-toggle="dropdown"
                >Sort By : {{ sortDisplay }}</a
              >
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="#"
                    class="dropdown-item rounded-1"
                    @click.prevent="sort('created_at', 'desc')"
                    >Recently Added</a
                  >
                </li>
                <li>
                  <a
                    href="#"
                    class="dropdown-item rounded-1"
                    @click.prevent="sort('role', 'asc')"
                    >Ascending</a
                  >
                </li>
                <li>
                  <a
                    href="#"
                    class="dropdown-item rounded-1"
                    @click.prevent="sort('role', 'desc')"
                    >Descending</a
                  >
                </li>
                <li>
                  <a
                    href="#"
                    class="dropdown-item rounded-1"
                    @click.prevent="sort('created_at', 'desc')"
                    >Last Month</a
                  >
                </li>
                <li>
                  <a
                    href="#"
                    class="dropdown-item rounded-1"
                    @click.prevent="sort('created_at', 'desc')"
                    >Last 7 Days</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <a-table
              class="table datatable thead-light"
              rowKey="id"
              :columns="columns"
              :data-source="sortedRoles"
              :loading="loading"
              :row-selection="rowSelection"
              @change="handleTableChange"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'role'">
                  {{ record.name }}
                </template>
                <template v-if="column.key === 'created'">
                  {{
                    record.created_at
                      ? new Date(record.created_at).toLocaleDateString()
                      : "--"
                  }}
                </template>
                <template v-if="column.key === 'status'">
                  <span
                    :class="[
                      'badge',
                      record.status === 'Active'
                        ? 'badge-success'
                        : record.status === 'Inactive'
                        ? 'badge-danger'
                        : 'd-inline-flex',
                      'align-items-center',
                      'badge-xs',
                    ]"
                  >
                    <i class="ti ti-point-filled me-1"></i>
                    {{ record.status || "Active" }}
                  </span>
                </template>
                <template v-if="column.key === 'action'">
                  <div class="action-icon d-inline-flex">
                    <router-link
                      v-can="'Role.Read'"
                      :to="`/user-management/roles-permissions/${record.id}/permissions`"
                      class="me-2"
                      title="Role permissions"
                    >
                      <i class="ti ti-shield"></i>
                    </router-link>
                    <a
                      href="javascript:void(0);"
                      class="me-2"
                      data-bs-toggle="modal"
                      data-bs-target="#role_modal"
                      @click="openEditModal(record)"
                      v-can="'Role.Edit'"
                    >
                      <i class="ti ti-edit"></i>
                    </a>
                   
                    <a
                      href="javascript:void(0);"
                      @click="deleteRole(record)"
                      v-can="'Role.Delete'"
                    >
                      <i class="ti ti-trash"></i>
                    </a>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
  <!-- /Page Wrapper -->
  <!-- <roles-modal  :roleData="currentRole"
    :isEdit="isEdit" ref="rolesModal" @saved="refreshRoleList" /> -->

    <roles-modal  :roleData="currentRole"
    :isEdit="isEdit"  @saved="refreshRoleList" />
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRoleStore } from "@/stores/roleStore";
import moment from "moment";
import DateRangePicker from "daterangepicker";
import "daterangepicker/daterangepicker.css";
import RolesModal from "@/components/modal/roles-modal.vue";

const title = "Roles & Permissions";
const text = "Administration";
const text1 = "Roles";

// Stores
const roleStore = useRoleStore();
const loading = ref(false);
const dateRangeInput = ref(null);
const selectedRoles = ref([]);

const filterStatusValue = ref("All");
const sortColumn = ref("");
const sortOrder = ref("asc");

const currentRole = ref(null);
const isEdit = ref(false);

function openEditModal(role) {
  console.log("Editing role:", role);
  currentRole.value = {  ...role }; // Clone to avoid direct mutation
  isEdit.value = true;
}

// Display sorting for dropdown
const sortDisplay = computed(() => {
  if (sortColumn.value === "role")
    return sortOrder.value === "asc" ? "Ascending" : "Descending";
  if (sortColumn.value === "created_at") return "Recently Added";
  return "Last 7 Days";
});

// Table columns
const columns = [
  { title: "Role", key: "role", sorter: true },
  { title: "Created Date", key: "created", sorter: true },
  { title: "Status", key: "status", sorter: true },
  { title: "", key: "action" },
];

// Filtering, Sorting, Data logic
const sortedRoles = computed(() => {
  let roles = [...roleStore.roles];
  if (filterStatusValue.value !== "All") {
    roles = roles.filter(
      (r) => (r.status || "Active") === filterStatusValue.value
    );
  }
  if (sortColumn.value) {
    roles.sort((a, b) => {
      let fieldA, fieldB;
      switch (sortColumn.value) {
        case "role":
          fieldA = (a.name || "").toLowerCase();
          fieldB = (b.name || "").toLowerCase();
          break;
        case "created_at":
          fieldA = a.created_at || "";
          fieldB = b.created_at || "";
          break;
        default:
          return 0;
      }
      if (fieldA < fieldB) return sortOrder.value === "asc" ? -1 : 1;
      if (fieldA > fieldB) return sortOrder.value === "asc" ? 1 : -1;
      return 0;
    });
  }
  return roles;
});

// Sorting events
function handleTableChange(pagination, filters, sorter) {
  if (sorter && sorter.columnKey) {
    sortColumn.value = sorter.columnKey;
    sortOrder.value = sorter.order === "ascend" ? "asc" : "desc";
  }
}

// Row selection
const rowSelection = {
  onChange: (keys) => (selectedRoles.value = keys),
};

// Filter status
function filterStatus(status) {
  filterStatusValue.value = status;
}

// Sorting from dropdown
function sort(col, order) {
  sortColumn.value = col;
  sortOrder.value = order;
}

async function deleteRole(role) {
  if (!role?.id) return;
  const label = role.name || "this role";
  if (
    !window.confirm(
      `Delete role "${label}"? Users assigned to it may lose access until reassigned.`,
    )
  ) {
    return;
  }
  await roleStore.deleteRole(role.id);
  await refreshRoleList();
}

// Refresh table
async function refreshRoleList() {
  loading.value = true;
  await roleStore.fetchRoles();
  loading.value = false;
}

// UI
function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

onMounted(() => {
  refreshRoleList();
  const start = moment().subtract(6, "days");
  const end = moment();
  new DateRangePicker(dateRangeInput.value, {
    startDate: start,
    endDate: end,
    ranges: {
      Today: [moment(), moment()],
      Yesterday: [moment().subtract(1, "day"), moment().subtract(1, "day")],
      "Last 7 Days": [moment().subtract(6, "days"), moment()],
      "Last 30 Days": [moment().subtract(29, "days"), moment()],
      "This Month": [moment().startOf("month"), moment().endOf("month")],
      "Last Month": [
        moment().subtract(1, "month").startOf("month"),
        moment().subtract(1, "month").endOf("month"),
      ],
    },
  });
});
</script>


